import { MongoObservable } from 'meteor-rxjs';
import { TranscribeJob } from '../models/transcribeJob';

export const TranscribeJobs = new MongoObservable.Collection<TranscribeJob>(
  'transcribeJobs',
);

if (Meteor.isServer) {
  TranscribeJobs.rawCollection().createIndex({ jobId: 1 });
  TranscribeJobs.rawCollection().createIndex({ customerId: 1 });
  TranscribeJobs.rawCollection().createIndex({ 'invitee.userId': 1 });
  TranscribeJobs.rawCollection().createIndex({ createdAt: 1 });
  TranscribeJobs.rawCollection().createIndex({
    'customer.id': 1,
    'bookingWebhook.status': 1,
    'bookingWebhook.retryCount': 1,
    'bookingWebhook.latestAttemptTimestamp': 1,
  });
}
